<section class="contractors-container bolt-container">
    <div class="bolt-heading-md bolt-space-bottom-lg">Contractors</div>

    <bolt-waiting-indicator class="bolt-space-inner-xl bolt-space-bottom-lg" *ngIf="contractorState === ContractorStateEnum.LOADING">Loading contractor information...
    </bolt-waiting-indicator>

    <div *ngIf="contractorState === ContractorStateEnum.HAS_CONTRACTORS" class="contractors-list">
        <p class="bolt-body-copy-lg">Here you'll find information about contractors or vendors assigned to your claim, if applicable.</p>
        <div *ngFor="let contractor of contractors" class="contractor-card bolt-space-bottom-lg">
            <div class="trade-label bolt-heading-xs bolt-space-bottom-sm">{{ contractor.trade }}</div>
            <div class="company-name bolt-body-copy-lg bolt-space-bottom-sm" ><strong>{{ contractor.companyName }}</strong></div>
            <div class="phone-number bolt-body-copy-lg bolt-body-font-weight-medium bolt-space-bottom-sm">
                <a href="tel:{{ contractor.phoneNumber }}" class="bolt-link phone-link">
                    {{ contractor.phoneNumber | phoneFormat }}
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="contractorState === ContractorStateEnum.NO_OFFERINGS" class="contractors-no-data">
        <p  class="bolt-body-copy-lg">Here you'll find information about contractors or vendors assigned to your claim, if applicable.</p>
    </div>

    <bolt-notification  *ngIf="contractorState === ContractorStateEnum.ERROR"  type="error" class="bolt-space-bottom-lg">
        No contractor details are available right now. Talk to your claims professional if you have questions.
    </bolt-notification>
</section>




